/* Formatadores pt-BR de moeda, percentual e data — puros, sem React. */

interface BrlOpts {
  sign?: boolean;
  cents?: boolean;
}

export function brl(v: number, { sign = false, cents = false }: BrlOpts = {}): string {
  const abs = Math.abs(v);
  const s = abs.toLocaleString("pt-BR", {
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
  const pre = v < 0 ? "−" : sign ? "+" : "";
  return pre + "R$ " + s;
}

interface PctOpts {
  sign?: boolean;
  dec?: number;
}

/** Fração (0.224) → "22,4%" */
export function pct(v: number, { sign = false, dec = 0 }: PctOpts = {}): string {
  const n = (Math.abs(v) * 100).toFixed(dec).replace(".", ",");
  const pre = v < 0 ? "−" : sign ? "+" : "";
  return pre + n + "%";
}

/** Valor já em pontos percentuais (4.2) → "4,2%" */
export function pctRaw(v: number, { sign = false, dec = 1 }: PctOpts = {}): string {
  const n = Math.abs(v).toFixed(dec).replace(".", ",");
  const pre = v < 0 ? "−" : sign ? "+" : "";
  return pre + n + "%";
}

const MESES = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

interface DataBrOpts {
  longa?: boolean;
}

/** ISO "2026-07-02" → "02/07/2026" (curta) ou "2 de julho de 2026" (longa).
 *  Parse manual: `new Date(iso)` interpretaria meia-noite UTC e renderizaria
 *  o dia anterior em fusos negativos (BRT). */
export function dataBr(iso: string, { longa = false }: DataBrOpts = {}): string {
  const [ano, mes, dia] = iso.split("-");
  if (longa) return `${Number(dia)} de ${MESES[Number(mes) - 1]} de ${ano}`;
  return `${dia}/${mes}/${ano}`;
}

/** ISO local "2026-06-09T14:32" → "09/06 às 14:32" (carimbo do último clique na
 *  auditoria). Parse manual pela mesma razão de `dataBr` (evitar shift de fuso do
 *  `Date`); sem hora → só "09/06". */
export function dataHoraBr(iso: string): string {
  // split sempre devolve ≥1 elemento, então `data` nunca é undefined de fato;
  // o default "" só satisfaz o tipo sem mudar o resultado para ISO válido.
  const [data = "", hora] = iso.split("T");
  const [, mes, dia] = data.split("-");
  if (!hora) return `${dia}/${mes}`;
  const [h, m] = hora.split(":");
  return `${dia}/${mes} às ${h}:${m}`;
}

/** ISO "2026-06-01" → "junho de 2026" (cabeçalho de calendário). */
export function mesAno(iso: string): string {
  const [ano, mes] = iso.split("-");
  return `${MESES[Number(mes) - 1]} de ${ano}`;
}

/** ROAS → 1 casa com vírgula decimal (ex.: 2.9 → "2,9"). */
export function roas(v: number): string {
  return v.toFixed(1).replace(".", ",");
}

export const fmt = { brl, pct, pctRaw, roas, dataBr, dataHoraBr, mesAno };
export type Fmt = typeof fmt;
